import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import api from '../services/api'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      isLoading: false,
      pendingToken: null,
      canais2FA: ['email'],

      login: async (email, password) => {
        set({ isLoading: true })
        try {
          const device_token = localStorage.getItem('device_token') || null
          const response = await api.post('/auth/login', { email, password, device_token })

          if (response.data.requires_phone) {
            set({ isLoading: false, pendingToken: response.data.pending_token })
            return { success: true, requiresPhone: true }
          }

          if (response.data.requires_2fa) {
            set({ isLoading: false, pendingToken: response.data.pending_token, canais2FA: response.data.canais || ['email'] })
            return { success: true, requires2fa: true }
          }

          await get()._concluirLogin(response.data)
          return { success: true }
        } catch (error) {
          set({ isLoading: false })
          return {
            success: false,
            error: error.response?.data?.detail || 'Erro ao fazer login'
          }
        }
      },

      submitPhoneFor2FA: async (telefone) => {
        set({ isLoading: true })
        try {
          const { pendingToken } = get()
          const response = await api.post('/auth/submit-phone-2fa', {
            pending_token: pendingToken,
            telefone,
          })
          set({ isLoading: false, pendingToken: response.data.pending_token, canais2FA: response.data.canais || ['whatsapp'] })
          return { success: true }
        } catch (error) {
          set({ isLoading: false })
          return {
            success: false,
            error: error.response?.data?.detail || 'Erro ao enviar código para o WhatsApp'
          }
        }
      },

      verifyTwoFactor: async (code, lembrarDispositivo = true) => {
        set({ isLoading: true })
        try {
          const { pendingToken } = get()
          const response = await api.post('/auth/verify-2fa', {
            pending_token: pendingToken,
            code,
            lembrar_dispositivo: lembrarDispositivo,
          })
          await get()._concluirLogin(response.data)
          return { success: true }
        } catch (error) {
          set({ isLoading: false })
          return {
            success: false,
            error: error.response?.data?.detail || 'Código inválido'
          }
        }
      },

      _concluirLogin: async (tokenData) => {
        const { access_token, device_token } = tokenData

        localStorage.setItem('token', access_token)
        if (device_token) {
          localStorage.setItem('device_token', device_token)
        }
        api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`

        const userResponse = await api.get('/auth/me')
        const user = userResponse.data

        set({
          token: access_token,
          user,
          isAuthenticated: true,
          isLoading: false,
          pendingToken: null,
        })

        // Redireciona para home (HomeRedirect decide qual dashboard)
        window.location.href = '/'
      },



      logout: () => {
        localStorage.removeItem('token')
        set({
          token: null,
          user: null,
          isAuthenticated: false
        })
        delete api.defaults.headers.common['Authorization']
        window.location.href = '/login'
      },

      checkAuth: async () => {
        const token = localStorage.getItem('token')
        if (!token) return false

        try {
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`
          
          // Tenta buscar dados do usuário para validar token
          const userResponse = await api.get('/auth/me')
          const user = userResponse.data
          
          set({ 
            token, 
            user,
            isAuthenticated: true 
          })
          return true
        } catch (error) {
          console.log('Token inválido ou expirado, fazendo logout')
          get().logout()
          return false
        }
      }
    }),
    {
      name: 'rematei-auth',
      partialize: (state) => ({ 
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated 
      })
    }
  )
)